/** Parse numeric product id from canonical slug `/p/brand-name-ean-123` or legacy `/p/123`. */
export function parseProductIdFromPath(segment: string): number {
  const s = segment.trim();
  if(!s) return 0;
  if(/^\d+$/.test(s)) return Number(s);
  const m = s.match(/-(\d+)$/);
  return m ? Number(m[1]) : 0;
}

export function productPath(slug: string): string {
  return `/p/${slug}`;
}

export function isLegacyNumericProductPath(segment: string): boolean {
  return /^\d+$/.test(segment.trim());
}
